"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var __1 = require("../");

var Icon_1 = require("../Icon/Icon");

var LogoMascot_1 = __importDefault(require("../LogoMascot/LogoMascot"));

var Popup_1 = require("../Popup/Popup");

var styled_1 = require("../styled");

var ContentItemsPopup =
/** @class */
function (_super) {
  __extends(ContentItemsPopup, _super);

  function ContentItemsPopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderTrigger = function (activeBreakpoint) {
      return function () {
        return react_1.default.createElement(styled_1.Trigger, null, react_1.default.createElement(Icon_1.Icon, {
          name: 'dots-vertical',
          size: Icon_1.IconSizeEnum.small
        }));
      };
    };

    _this.generateMenuOptions = function (activeBreakpoint) {
      var _a = _this.props,
          showPrivacy = _a.showPrivacy,
          showTerms = _a.showTerms,
          disableLogin = _a.disableLogin,
          disableRegister = _a.disableRegister,
          navigation = _a.navigation;
      var options = [{
        render: function render() {
          return react_1.default.createElement(styled_1.OptionHeaderContainer, {
            withBorder: false
          }, react_1.default.createElement(LogoMascot_1.default, {
            activeBreakpoint: activeBreakpoint,
            color: "purple",
            version: {
              sm: 'image',
              lg: 'image'
            }
          }), react_1.default.createElement(styled_1.CloseContainer, null, react_1.default.createElement(styled_1.CloseText, null, "Close menu"), react_1.default.createElement(Icon_1.Icon, {
            name: 'close',
            size: Icon_1.IconSizeEnum.small
          })));
        },
        disabled: false
      }, {
        onSelect: showPrivacy,
        render: function render() {
          return react_1.default.createElement(styled_1.OptionContainer, {
            withBorder: true
          }, react_1.default.createElement(Icon_1.Icon, {
            name: 'information-outline',
            size: Icon_1.IconSizeEnum.small
          }), react_1.default.createElement(styled_1.OptionText, null, "Privacy Policy"));
        },
        disabled: false
      }, {
        onSelect: showTerms,
        render: function render() {
          return react_1.default.createElement(styled_1.OptionContainer, {
            withBorder: true
          }, react_1.default.createElement(Icon_1.Icon, {
            name: 'information-outline',
            size: Icon_1.IconSizeEnum.small
          }), react_1.default.createElement(styled_1.OptionText, null, "Terms & Conditions"));
        },
        disabled: false
      }, {
        onSelect: function onSelect() {
          return navigation.navigate(routes_1.RoutesKeysEnum.contact);
        },
        render: function render() {
          return react_1.default.createElement(styled_1.OptionContainer, {
            withBorder: true
          }, react_1.default.createElement(Icon_1.Icon, {
            name: 'information-outline',
            size: Icon_1.IconSizeEnum.small
          }), react_1.default.createElement(styled_1.OptionText, null, "Contact Us"));
        },
        disabled: false
      }];

      if (!disableRegister) {
        options.splice(1, 0, {
          onSelect: function onSelect() {
            return navigation.navigate(routes_1.RoutesKeysEnum.signup, utilities_1.navigateWithAccessCodeQueryParam(navigation.getParam));
          },
          render: function render() {
            return react_1.default.createElement(styled_1.OptionContainer, {
              withBorder: true
            }, react_1.default.createElement(Icon_1.Icon, {
              name: 'account',
              size: Icon_1.IconSizeEnum.small
            }), react_1.default.createElement(styled_1.OptionText, null, "Create Account"));
          },
          disabled: false
        });
      }

      if (!disableLogin) {
        options.splice(1, 0, {
          onSelect: function onSelect() {
            return navigation.navigate(routes_1.RoutesKeysEnum.login, utilities_1.navigateWithAccessCodeQueryParam(navigation.getParam));
          },
          render: function render() {
            return react_1.default.createElement(styled_1.OptionContainer, {
              withBorder: true
            }, react_1.default.createElement(Icon_1.Icon, {
              name: 'account',
              size: Icon_1.IconSizeEnum.small
            }), react_1.default.createElement(styled_1.OptionText, null, "Log In"));
          },
          disabled: false
        });
      }

      return options;
    };

    _this.getPopupRenderer = function (activeBreakpoint) {
      if (responsive_1.isSmall(activeBreakpoint)) {
        return Popup_1.Popup.Renderers.SlideInMenuTop;
      }

      return Popup_1.Popup.Renderers.Popover;
    };

    return _this;
  }

  ContentItemsPopup.prototype.render = function () {
    var _this = this;

    return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
      var activeBreakpoint = _a.activeBreakpoint;
      return react_1.default.createElement(__1.RowCentered, null, react_1.default.createElement(Popup_1.Popup, {
        renderer: _this.getPopupRenderer(activeBreakpoint),
        renderTrigger: _this.renderTrigger(activeBreakpoint),
        disabled: false,
        options: _this.generateMenuOptions(activeBreakpoint),
        optionsCustomStyles: styled_1.popupOptionsCustomStyles(activeBreakpoint),
        triggerCustomStyles: styled_1.dotsTriggerCustomStyles,
        rendererProps: {
          placement: 'top'
        }
      }));
    });
  };

  return ContentItemsPopup;
}(react_1.default.Component);

exports.ContentItemsPopup = ContentItemsPopup;